export const PLAYERS_SELECT_SELECTOR = '#players';
